// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"c66067e8","126":"91ee86f8","162":"c73c32b0","171":"7f91efcc","491":"bd83bed1"}[chunkId] + ".chunk.js";
};